import LandPage from './LandPage';
import WeekSpecials from './ThisWeekSpecials';
import Testimonials from './Testimonials';
import OurStory from './OurStory';

const Home = () => {
  return (
    <>
      <LandPage />
      <WeekSpecials />
      <Testimonials />
      <OurStory />
    </>
  );
};

export default Home;
